// Pure logic for the single Activity-level Time Zone control. Kept out of the
// Vue component so it is unit-testable (Node) and reusable. CommonJS for
// Node-test + webpack interop.
//
// The Activity editor shows ONE Time Zone selector that stands in for the two
// stored values (start_time_zone / end_time_zone). Behavior:
//   - Display the Start time zone as the Activity Time Zone. For a legacy
//     Activity whose stored start/end zones differ, Start wins for display.
//   - Do NOT modify either stored value merely by opening (and saving) the
//     form: while the control is untouched, submit the ORIGINAL start/end
//     values unchanged, so a legacy mismatch is never silently normalized.
//   - On an explicit change, set BOTH stored values to the selected value.
// "Touched" is distinguishable from a plain save because it is driven by the
// select's change event, not merely by the field being present.

function displayTimezone(startTimezone) {
  return startTimezone;
}

function submittedTimezones({ startTimezone, endTimezone, selectedTimezone, touched }) {
  if (touched) {
    return { start: selectedTimezone, end: selectedTimezone };
  }
  return { start: startTimezone, end: endTimezone };
}

module.exports = { displayTimezone, submittedTimezones };
